/**
 * Aus der Angebots-/Rechnungsübersicht darf nur gelöscht werden, was nicht steuerrelevant ist.
 * Rechnungen (inkl. Abschlags-, Schluss- und Stornorechnungen) sind nach GoBD aufbewahrungspflichtig
 * und werden ausschließlich storniert bzw. korrigiert. Das Backend erzwingt das zusätzlich.
 */
const OVERVIEW_DELETABLE_DOCUMENT_TYPES = new Set(['offer']);

/** Steuerrelevante Belege — PDF am Projekt darf nicht gelöscht werden (GoBD). */
const TAX_RELEVANT_INVOICE_DOCUMENT_TYPES = new Set([
  'invoice',
  'partial_invoice',
  'final_invoice',
  'credit_note',
  'invoice_correction',
  'incoming_invoice',
  'incoming_invoice_correction',
  'supplier_invoice',
]);

export function isTaxRelevantInvoiceDocumentType(documentType: string | null | undefined): boolean {
  return TAX_RELEVANT_INVOICE_DOCUMENT_TYPES.has(String(documentType ?? '').trim());
}

export function isDeletableFromOverview(row: { document_type?: string | null }): boolean {
  return OVERVIEW_DELETABLE_DOCUMENT_TYPES.has(String(row.document_type ?? '').trim());
}
